// extracted by mini-css-extract-plugin
export var crossed = "style-module--crossed--c148d";
export var form = "style-module--form--b6940";
export var info = "style-module--info--e6e8d";
export var policy = "style-module--policy--67dc8";
export var price = "style-module--price--5ad98";
export var priceWrap = "style-module--price-wrap--40631";
export var reg = "style-module--reg--123c8";
export var res = "style-module--res--f81b6";
export var text = "style-module--text--d49e9";